import {isUserPAYG} from '@Libraries/user.library';
import {assertNever} from '@Utils/assert-never.util';
import {getPublishingOptionLabel} from '@Components/ai-chat-window/lib/publish-copy.library';
import type {PublishingOptionDefinition, PublishingOptionHandlers} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';
import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';

export function getPublishingOptionDefinition(option: PublishingOption, handlers: PublishingOptionHandlers): PublishingOptionDefinition {
  const text = getPublishingOptionLabel(option);

  switch (option) {
    case PublishingOption.PUBLISH_TO_SOCIAL_MEDIA:
      return {icon: 'icon-social-media', text, hasPremiumCrown: false, publish: handlers.publishToSocialMedia};
    case PublishingOption.PROMOTE_AS_EVENT:
      return {icon: 'icon-event', text, hasPremiumCrown: false, publish: handlers.promoteAsEvent};
    case PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN:
      return {icon: isUserPAYG() ? 'icon-crown' : 'icon-envelope', text, hasPremiumCrown: isUserPAYG(), publish: handlers.publishAsEmailCampaign};
    default:
      return assertNever(option);
  }
}
